import { IUser, IUserAdminRouteHistory } from '@/pages/Users/users.types.ts'
import Table, { ITableField } from '@/shared/Tables/Table'
import useTableWithRequest from '@/shared/Tables/Table/ctrl/useTableWithRequest.ts'
import usersApi from '@/pages/Users/users.api.ts'
import { HTTPResponse, IPaginationResponse } from '@/services/http/http.types.ts'
import { useCallback, useState } from 'react'
import timeUtils from '@/utils/time.utils.ts'
import EmptyPlaceholder from '@/shared/Common/EmptyPlaceholder'

interface IProps {
  userId: IUser['id']
}

interface IUserAdminRouteHistoryTableItem extends IUserAdminRouteHistory {
  _rowKey: string
}

const fields: ITableField<IUserAdminRouteHistoryTableItem, keyof IUserAdminRouteHistoryTableItem>[] = [
  {
    key: 'createdAt',
    clientSideOrdering: true,
    width: '180px',
    header: 'Дата',
    getter: (item) => (item.createdAt ? timeUtils.formatDate(new Date(item.createdAt), 'dd MMM yyyy, HH:mm:ss') : '-'),
    sortGetter: (item) => (item.createdAt ? new Date(item.createdAt).getTime() : 0),
  },
  {
    key: 'routeName',
    clientSideOrdering: true,
    width: '380px',
    header: 'Маршрут',
    getter: (item) => item.routeName || '-',
    sortGetter: (item) => item.routeName || '',
  },
]

const UserAdminRoutesHistoryTable = (props: IProps) => {
  const [items, setItems] = useState<IUserAdminRouteHistoryTableItem[]>([])

  const dataLoad = useCallback(
    async (
      params: Record<string, string | number>
    ): Promise<HTTPResponse<IPaginationResponse<IUserAdminRouteHistoryTableItem>>> => {
      const resp = await usersApi.getAdminRoutesHistory(props.userId, params)

      if (resp.status !== 'success') return resp

      return {
        ...resp,
        body: {
          ...resp.body,
          items: resp.body.items.map((item, index) => ({
            ...item,
            _rowKey: item.id?.toString() || `${item.routeName}-${item.createdAt || 'unknown'}-${index}`,
          })),
        },
      }
    },
    [props.userId]
  )

  const tableCtrl = useTableWithRequest({
    serverSideOrder: false,
    fields,
    tableKey: `users/${props.userId}/admin/routes-history`,
    itemKey: '_rowKey',
    dataFetcher: dataLoad,
    items,
    setItems,
    storageType: 'inMemory',
  })

  return (
    <div className="height100" style={{ flex: 1, minHeight: 0 }}>
      {!tableCtrl.loading && tableCtrl.totalItemsCount === 0 ? (
        <div className="flex-lines center height100">
          <EmptyPlaceholder inscription="История переходов пуста" />
        </div>
      ) : (
        <Table {...tableCtrl} items={tableCtrl.orderedItems as any} itemKey="_rowKey" />
      )}
    </div>
  )
}

export default UserAdminRoutesHistoryTable
